import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { Store } from '@ngxs/store';
import { NavigationService } from '@services/nav/nav.service';
import { BusinessFeatureFlagSelectors, BusinessState } from '@state/business';
import { filter, map, switchMap, tap } from 'rxjs/operators';

export const EmailTemplatesGuard: CanActivateFn = () => {
	const navService = inject(NavigationService);
	const store = inject(Store);
	return store.select(BusinessState.getLoaded).pipe(
		filter((loaded) => loaded),
		switchMap(() =>
			store.select(BusinessFeatureFlagSelectors.isEmailTemplatesEnabled),
		),
		tap(
			(isEmailTemplatesEnabled) =>
				!isEmailTemplatesEnabled && navService.goToDashboard(),
		),
		map((isEmailTemplatesEnabled) => isEmailTemplatesEnabled),
	);
};
